export default __webpack_public_path__ + "static/media/DinersClub.95f57162.png";